import { showToast } from './toast';
function shareProfile() {
    const currentUrl = window.location.href;
    navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
            showToast('Profile link copied!');
        })
        .catch(() => {
            showToast('Failed to copy. Try again.');
        });
}
const shareBtn = document.getElementById('shareProfileBtn');

if (shareBtn) {
    shareBtn.addEventListener('click', shareProfile);
}
